import axios from "axios";
//import { clearToken } from "../utils/manageStore";
const BASE_URL = process.env.REACT_APP_API_URL||"http://localhost:8001/api";
const BASE_URL_TIMEZONE = "http://talentrivers.com/TimeZone";
let isRefreshing = false;
let failedQueue = [];

const apiClient = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    "Content-type": "application/json",
  }
});

const apiTimezone = axios.create({
  baseURL: `${BASE_URL_TIMEZONE}`,
  headers: {
    "Content-type": "application/json",
  }
});



apiClient.interceptors.request.use((config) => {
  //const accesToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOjIsImlhdCI6MTczMjc5MzM4OCwiZXhwIjoxNzMyNzk2OTg4fQ.pOyr-vaHT5hblogwE-EYLAC71lIEYQ5x8OXQDfiBzwY";//localStorage.getItem("token")
  const accesToken = localStorage.getItem("token")
  if (accesToken) {
    config.headers.Authorization = `Bearer ${accesToken}`
  }
  return config;
},
  (error) => {
    return Promise.reject(error)
  }
);


const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });
  failedQueue = [];
};

apiClient.interceptors.response.use(
  (response) => response, // Handle success responses
  async (error) => {
    // debugger;
  
    const originalRequest = error.config;
    // Check if the error is due to an expired token
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return apiClient(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // debugger
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) throw new Error('No refresh token available');

        // Call your refresh token endpoint
        const { data } = await axios.post(BASE_URL+'/auth/refresh', {
          refreshToken,
        });

        const newAccessToken = data.accessToken;
        const newrefreshToken = data.refreshToken;
        localStorage.setItem('token', newAccessToken);
        localStorage.setItem('refreshToken', newrefreshToken);

        processQueue(null, newAccessToken);

        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return apiClient(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);


// apiClient.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       clearToken()
//     }
//     return Promise.reject(error);
//   }
// );

export async function get(path) {
  try {
console.log(path);
    const response = await apiClient.get(path);
    return response;
  } catch (error) {
    return error;
  }
}
export async function getTimezone(path) {
  try {  
    const response = await apiTimezone.get(path);
    return response;
  } catch (error) {
    console.error("getTimezone error:", error.message);
    console.error("Error details:", error);
    return error;
  }
}

export async function put(path, data, contentType='json') {
  try {
    let headers = {};
    headers['Content-Type'] = 'application/json';
    if (contentType != 'json') {      
      headers['Content-Type'] = 'multipart/form-data'; // FormData automatically sets this
    } 
    const response = await apiClient.put(path, data ,{headers});
    return response?.data;
  } catch (error) {
    return error;
  }
}

export async function post(path, reqData,contentType='json') {
  try {
    let headers = {};
    headers['Content-Type'] = 'application/json';
    if (contentType != 'json') {      
      headers['Content-Type'] = 'multipart/form-data'; // FormData automatically sets this
    } 
    // debugger
    const response = await apiClient.post(path, reqData,{ headers });
    // debugger
    return response;

  } catch (error) {
    return error;
  }

}


export async function del(path) {
  try {
    const response = await apiClient.delete(path);
    return response.data;
  } catch (error) {
    return error;
  }
}


export async function getResume(path) {
  try {
    const response = await apiClient.get(path, {
      responseType: 'arraybuffer', // Ensures we handle binary data (like a file)
    });
    return response;
  } catch (error) {
    console.error("Error while fetching file:", error);
    throw new Error("Error while fetching the file");
  }
}